import React, {useEffect, useState} from "react";
import {AddMenuStyles} from "components/atoms/MenuManagement/MenuManagement.styles";
import infoIcon from "assets/infoIcon.svg";
import {useForm} from "components/molecules/Form";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import Button from "components/molecules/Button";
import ReactDateRange from "components/atoms/DatePicker";
import {setHours, setMinutes} from "date-fns";
import {GiCheckMark} from "react-icons/gi";
import menuStoreService from "services/menu-storeService";
import {useAuthContext} from "Context/authContext";
import {format, parse} from "date-fns";
import Toast from "components/molecules/Toast";
import {useSelector} from "react-redux";
import {IoMdArrowDropdown} from "react-icons/io";
import {MdInfo} from "react-icons/md";
const daysData = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const AddMenu = ({editMenu, onClose, menuId, handleCategoryModal}) => {
    const [form] = useForm();
    const [minHours, setMinHours] = useState(0);
    const [minMinutes, setMinMinutes] = useState(0);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [selectDay, setSelectDay] = useState([]);
    const [isAllDay, setIsAllDay] = useState(false);
    const {refetch, user} = useAuthContext();
    const defaultStore = useSelector(state => state.business.defaultStore);
    const businessId = useSelector(state => state.business.businessId);
    const [loading, setLoading] = useState(false);
    // const businessId = sessionStorage.getItem(
    //   process.env.REACT_APP_BUSINESS_SESSION
    // );
    const {menu, menu_loading} = menuStoreService.GetMenuById(menuId);

    useEffect(() => {
        if (menu && !menu_loading) {
            form.setFieldsValue({
                menu_title: menu?.menuTitle,
                menu_desc: menu?.menuDescription,
            });
            setSelectDay(menu?.days);
            setStart(menu?.startTime);
            setEnd(menu?.endTime);

            // Check if it's a 24-hour menu
            const isAllDayMenu = menu?.startTime === "00:00" && menu?.endTime === "23:59";
            setIsAllDay(isAllDayMenu);

            const currentDate = new Date();
            const dateWithStartTime = parse(menu?.startTime, "HH:mm", currentDate);
            setStartTime(dateWithStartTime);
            const dateWithEndTime = parse(menu?.endTime, "HH:mm", currentDate);
            setEndTime(dateWithEndTime);
        }
    }, [menu, menuId]);

    function handleSelectDay(item) {
        if (selectDay.includes(item)) {
            setSelectDay(prev => prev.filter(elem => elem !== item));
        } else {
            setSelectDay(prev => [...prev, item]);
        }
    }

    function handleSelectAllDays() {
        if (selectDay.length === daysData.length) {
            setSelectDay([]);
        } else {
            setSelectDay([...daysData]);
        }
    }

    function handleAllDayToggle() {
        setIsAllDay(!isAllDay);
        if (!isAllDay) {
            // Set to 24 hours (00:00 to 23:59)
            const startDate = new Date();
            startDate.setHours(0, 0, 0, 0);
            const endDate = new Date();
            endDate.setHours(23, 59, 0, 0);

            setStartTime(startDate);
            setEndTime(endDate);
            setStart("00:00");
            setEnd("23:59");
        }
    }

    useEffect(() => {
        if (startTime !== null) {
            setMinHours(startTime?.getHours());
            setMinMinutes(startTime?.getMinutes());
        }
        if (startTime === null) {
            setMinHours(0);
            setMinMinutes(0);
        }
    }, [startTime]);

    const handleTimeSelect = e => {
        const formattedTime = format(new Date(e?.target?.value), "HH:mm");
        if (e?.target?.name === "startTime") {
            setStart(formattedTime);
            setStartTime(e?.target?.value);
        } else if (e?.target?.name === "endTime") {
            setEnd(formattedTime);
            setEndTime(e?.target?.value);
        }
    };

    const handleSubmit = async data => {
        try {
            setLoading(true);
            const payload = {
                days: selectDay,
                startTime: start,
                endTime: end,
                menuTitle: data.menu_title,
                menuDescription: data.menu_desc,
                branch: defaultStore,
                restaurant: businessId || (Array.isArray(user?.businessId) ? user?.businessId[0] : user?.businessId),
            };
            let newMenuId = menuId;
            if (!editMenu) {
                const response = await menuStoreService.createMenu(payload);
                console.log("Menu creation response:", response);
                // Handle new response format with menuId directly in response
                newMenuId = response?.menuId || response?.data?._id || response?._id;
                console.log("Extracted newMenuId:", newMenuId);
            } else {
                await menuStoreService.updateMenu(payload, menuId);
            }
            // refetch();
            setLoading(false);
            if (!editMenu) {
                if (newMenuId) {
                    console.log("Calling handleCategoryModal with menuId:", newMenuId);
                    handleCategoryModal(newMenuId);
                } else {
                    console.log("No newMenuId found, calling handleCategoryModal without ID");
                    handleCategoryModal();
                }
            }
            onClose();
        } catch (error) {
            Toast({
                type: "error",
                message: error?.message,
            });
            setLoading(false);
        }
    };

    return (
        <AddMenuStyles>
            {/* <strong className="title">Menu Details</strong> */}
            <div className="info">
                {/* <img src={infoIcon} alt="infoIcon" /> */}
                <span>
                    <MdInfo />
                </span>
                <p>
                    Customers will be able to order from a menu between the hours specified. Each menu contains items
                    that are grouped by categories.
                </p>
            </div>
            <Form form={form} onSubmit={handleSubmit}>
                <div className="combine-fields">
                    <Form.Item
                        label="Menu Title *"
                        type="text"
                        rounded
                        name="menu_title"
                        lg
                        placeholder="Enter your menu title"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Menu title is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label="Menu Description *"
                        type="text"
                        rounded
                        name="menu_desc"
                        lg
                        placeholder="Starter: Truffle mac & cheese bites  Main: Buttermilk fried chicken with garlic mashed potatoes  Side: Roasted seasonal vegetables  Dessert: Warm chocolate lava cake with vanilla ice cream  Drink: Homemade lemonade with mint"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Menu description is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                </div>
                <hr />
                <strong className="title">Menu Availability</strong>
                <div className="info">
                    {/* <img src={infoIcon} alt="infoIcon" /> */}
                    <span>
                        <MdInfo />
                    </span>
                    <p>
                        Select when this menu will be available to customers. Only one menu can be available at any
                        given time. If you have two or more menus on the same day, make sure there is no gap in time
                        between menus.
                    </p>
                </div>
                <div className="select-all-container">
                    <div
                        className={selectDay.length === daysData.length ? "day active select-all" : "day select-all"}
                        onClick={handleSelectAllDays}>
                        <GiCheckMark className="icon" />
                        <span>Select All</span>
                    </div>
                </div>
                <div className="week">
                    {daysData.map((item, index) => (
                        <div
                            className={selectDay.includes(item) ? "day active" : "day"}
                            key={index}
                            onClick={() => handleSelectDay(item)}>
                            <GiCheckMark className="icon" />
                            <span>{item}</span>
                        </div>
                    ))}
                </div>
                <div className="all-day-container">
                    <div
                        className={isAllDay ? "day active all-day-toggle" : "day all-day-toggle"}
                        onClick={handleAllDayToggle}>
                        <GiCheckMark className="icon" />
                        <span>24 Hours / All Day</span>
                    </div>
                </div>
                <div className="date-picker">
                    <ReactDateRange
                        endLabel="Time End"
                        startLabel="Time Start"
                        $bgWhite
                        onChange={handleTimeSelect}
                        startTime={startTime}
                        endTime={endTime}
                        minTime={setHours(setMinutes(new Date(), minMinutes), minHours)}
                        maxTime={setHours(setMinutes(new Date(), 30), 23)}
                        timeOnly
                        menuPosition="fixed"
                        suffix={<IoMdArrowDropdown className="dropdownicon" />}
                        disabled={isAllDay}
                    />
                </div>
                {editMenu ? (
                    <div className="btn-holder">
                        <Button
                            width="300px"
                            danger
                            onClick={() => {
                                onClose();
                            }}>
                            Delete Menu
                        </Button>
                        <Button width="300px" loader={loading}>
                            Save Changes
                        </Button>
                    </div>
                ) : (
                    <div className="btn-holder">
                        <Button width="300px" loader={loading}>
                            Create Menu
                        </Button>
                    </div>
                )}
            </Form>
        </AddMenuStyles>
    );
};

export default AddMenu;
